import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default class extends Controller {
    static targets = ['slider', 'slide', 'pagination', 'nextButton', 'prevButton'];

    connect() {
        // Create Swiper instance first without fixed dimensions
        const carousel = new Swiper(this.sliderTarget, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            loop: true,
            updateOnWindowResize: false,
            observer: false,
            observeParents: false,
            resizeObserver: false,
            autoHeight: false,
            pagination: {
                el: this.paginationTarget,
                clickable: true,
            },
            navigation: {
                nextEl: this.nextButtonTarget,
                prevEl: this.prevButtonTarget,
            },
        });

        // Wait for layout to stabilize
        setTimeout(() => {
            requestAnimationFrame(() => {
                this.updateDimensions(carousel);
            });
        }, 100);

        // Handle window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            // Debounce resize updates
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                requestAnimationFrame(() => {
                    this.updateDimensions(carousel);
                });
            }, 100);
        });
    }

    updateDimensions(carousel) {
        const containerWidth = this.element.parentElement.offsetWidth;
        const containerHeight = this.element.parentElement.offsetHeight;

        console.log('Updating dimensions:', containerWidth, containerHeight);

        // Update slides
        this.slideTargets.forEach(slide => {
            slide.style.width = `${containerWidth}px`;
            slide.style.height = `${containerHeight}px`;
        });

        // Update container
        this.sliderTarget.style.width = `${containerWidth}px`;
        this.sliderTarget.style.height = `${containerHeight}px`;

        // Update Swiper
        carousel.params.width = containerWidth;
        carousel.params.height = containerHeight;
        carousel.update();
    }
}
